import { AWAY } from '../../reassignment/constants/agent-state';
export const CUSTOM_TIME = 'custom-time';
export const AWAY_STATUS_TIMER_ALERT_TIMEOUT = 3000;
export const calculateDurationMinutes = formState => {
  if (formState.status !== AWAY) {
    return undefined;
  }
  if (formState.time === CUSTOM_TIME) {
    return formState.customTime;
  }
  return formState.time;
};
export const getRemainingMinutes = awayStatusTimer => {
  if (!awayStatusTimer) {
    return 0;
  }
  const {
    durationMins,
    timerStartedAt
  } = awayStatusTimer;
  const endTime = timerStartedAt + durationMins * 60 * 1000;
  if (Date.now() >= endTime) {
    return 0;
  }
  return Math.ceil((endTime - Date.now()) / (60 * 1000));
};